import ObSkeleton from '@/components/LoadingSkeleton/Skeleton.vue';
import ObSkeletonTheme from '@/components/LoadingSkeleton/SkeletonTheme.vue';
export const registerObSkeleton = app => {
  app.component(ObSkeleton.name, ObSkeleton);
  app.component(ObSkeletonTheme.name, ObSkeletonTheme);
};